import React, { useState, useEffect } from 'react';
import './App.css';
import FileUploadSystem from './components/FileUploadSystem';
import AuthForm from './components/AuthForm'; // Import AuthForm
import { getAuth, onAuthStateChanged } from 'firebase/auth'; // Import Firebase auth

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      setUser(authUser);
      setLoading(false);
    });
    
    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);
  
  return (
    <div className="app">
      <header>
        
        <h1>ABCS/ABFCS Content Portal</h1>
        <p>Resource Repository & Discussion Board</p>
      </header>
      
      <main>
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        ) : !user ? (
          <AuthForm />
        ) : (
          <FileUploadSystem user={user} />
        )}
      </main>
      
      <footer>
        <p>&copy; {new Date().getFullYear()} Cosknow Learning Platform</p>
      </footer>
    </div>
  );
}

export default App;